import { Star, Quote } from "lucide-react";
import { FadeUp } from "./Motion";

const TESTIMONIALS = [
  {
    name: "Carlos Mendes",
    treatment: "Micose nas Unhas",
    text: "Lutei contra micose nas unhas por anos. Com o tratamento correto da Rosa Chagas, finalmente consegui resolver. Muito grato pela dedicação e competência.",
    initial: "C",
  },
  {
    name: "Maria Silva",
    treatment: "Unha Encravada",
    text: "Estava com muita dor por causa de uma unha encravada. Em uma sessão na Podomasso fiquei sem dor. Atendimento humanizado e profissional!",
    initial: "M",
  },
  {
    name: "João Santos",
    treatment: "Pé Diabético",
    text: "Sou diabético e a Rosa cuida dos meus pés há anos. Atenção, biossegurança e orientação completa. Recomendo de olhos fechados.",
    initial: "J",
  },
  {
    name: "Ricardo Lima",
    treatment: "Verruga Plantar",
    text: "O tratamento para o 'olho de peixe' foi excelente. Em poucas sessões a dor sumiu e a pele cicatrizou perfeitamente. Clínica muito limpa e organizada.",
    initial: "R",
  },
  {
    name: "Ana Paula Costa",
    treatment: "Pés Ressecados",
    text: "Fiz a hidratação profunda e meus pés parecem outros. Estavam muito rachados e agora estão super macios. A Rosa é uma excelente profissional.",
    initial: "A",
  },
  {
    name: "Roberto Ferreira",
    treatment: "Órtese Ungueal",
    text: "Usei o aparelho na unha por 4 meses e resolveu meu problema de unha encravada recorrente. Procedimento indolor e com resultado garantido.",
    initial: "R",
  },
];

export function Testimonials() {
  return (
    <section className="bg-secondary/40 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <FadeUp>
          <div className="mb-12 text-center">
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary">
              Depoimentos dos Nossos Pacientes
            </p>
            <h2 className="font-display text-3xl font-bold sm:text-4xl lg:text-5xl">
              O Que Dizem Sobre a Podomasso
            </h2>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-background px-4 py-2 shadow-soft">
              <div className="flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-sm font-semibold">5.0 no Google</span>
            </div>
          </div>
        </FadeUp>

        <div className="grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <FadeUp key={t.name} delay={i * 0.1}>
              <div className="relative h-full rounded-2xl bg-gradient-card p-7 shadow-card">
                <Quote className="absolute right-5 top-5 h-10 w-10 text-primary/15" />
                <div className="mb-4 flex">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="mb-6 text-sm leading-relaxed text-foreground/90">"{t.text}"</p>
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-hero font-semibold text-primary-foreground">
                    {t.initial}
                  </div>
                  <div>
                    <p className="text-sm font-semibold">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.treatment}</p>
                  </div>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
